<!-- eslint-disable @angular-eslint/template/no-negated-async -->
<h2 class="bd-title">Failover</h2>
@if ((isFailOverAllowed$ | async) === false) {
<alert type="warning">
  <coso-alert-message>
    Your license does not include this feature. Please contact us to add this feature to your license, or ask for a trial license if you want to try out this feature.
  </coso-alert-message>
</alert>
}

<form #settingsForm="ngForm" id="settingsForm">
  @if (settings$ | async; as settings) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label for="highAvailabilityMode" class="cs-larger-text cs-bolder-text">Failover support</label>
      <div id="highAvailabilityModeSubLabel" class="cs-secondary-text">
        Configure failover mode. Depending on your license, the setting will be valid for <i>Permission Replicator</i> or <i>Structure Creator</i> or both.
        <ul>
          <li>None: this instance is the only one responsible for processing (default option).</li>
          <li>Main instance: this instance is responsible for processing. It is monitored by the backup instance which takes over in case of failure or down time.</li>
          <li>
            Backup instance: this instance is responsible for performing periodical checks on the main instance. If the main instance becomes unavailable, this instance starts the replication process
            or handle Structure Creator logic.
          </li>
        </ul>
      </div>
    </div>
    <div class="cs-field-wrapper">
      <select
        class="form-control"
        id="highAvailabilityMode"
        name="highAvailabilityMode"
        aria-describedby="highAvailabilityModeSubLabel"
        [(ngModel)]="settings.highAvailabilityMode"
        (ngModelChange)="onHighAvailabilityModeChanged(settings)"
        [disabled]="readonly || (isFailOverAllowed$ | async) === false"
      >
        <option [ngValue]="HighAvailabilityModes.None">None</option>
        <option [ngValue]="HighAvailabilityModes.FailoverMain">Main instance</option>
        <option [ngValue]="HighAvailabilityModes.FailoverBackup">Backup instance</option>
      </select>
    </div>
  </div>
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label for="crmHeartbeatInterval" class="cs-larger-text cs-bolder-text">Heartbeat interval</label>
      <div id="crmHeartbeatIntervalSubLabel" class="cs-secondary-text">
        Set the interval (in seconds) at which the main instance notifies its state to backup instances. The recommended value is between 10 and 60 seconds.
      </div>
    </div>
    <div class="cs-field-wrapper">
      <input
        type="number"
        class="form-control"
        id="crmHeartbeatInterval"
        name="crmHeartbeatInterval"
        #crmHeartbeatInterval="ngModel"
        min="1"
        max="99"
        [class.is-invalid]="crmHeartbeatInterval.touched && crmHeartbeatInterval.invalid"
        cosoRangeValidator
        [attr.aria-invalid]="crmHeartbeatInterval.invalid"
        [attr.aria-describedby]="'crmHeartbeatIntervalSubLabel' + (crmHeartbeatInterval.touched && crmHeartbeatInterval.invalid ? ' crmHeartbeatInterval-errors' : '')"
        [(ngModel)]="settings.crmHeartbeatInterval"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="readonly || !(isFailOverAllowed$ | async) || settings.highAvailabilityMode !== HighAvailabilityModes.FailoverMain"
      />
      <span class="fa fa-times invalid-feedback-icon" aria-hidden="true"></span>
      @if (crmHeartbeatInterval.touched && crmHeartbeatInterval.invalid) { @if (crmHeartbeatInterval.errors?.min) {
      <div class="invalid-feedback" id="crmHeartbeatInterval-errors" role="alert">The Heartbeat interval field must be greater than or equal to 1.</div>
      } @if (crmHeartbeatInterval.errors?.max) {
      <div class="invalid-feedback" id="crmHeartbeatInterval-errors" role="alert">The Heartbeat interval field must be less than or equal to 99.</div>
      } }
    </div>
  </div>
  }
</form>
